"use client";

import { useEffect, useState } from "react";
import Selector from "./Selector";
import ChartPreviewContent from "./ChartPreviewContent";

export default function ChartPreview(props: any) {
  const [selectedDivision, setSelectedDivision] = useState<{[datasetId: string]: string}>({});

  useEffect(() => {
    console.log('selectedDivisionIHV3: ', props.selectedDivisionIHV3);

    const collectDivisionSelections = (
      chartInfo: any,
      selectedDivision: { id?: string } | null | undefined
    ): Record<string, string> => {
      const out: Record<string, string> = {};
      if (!chartInfo || !selectedDivision?.id) return out;

      for (const sectionKey of Object.keys(chartInfo)) {
        const divisionItems = chartInfo[sectionKey]?.divisionItems;
        if (
          divisionItems &&
          Object.prototype.hasOwnProperty.call(divisionItems, selectedDivision.id)
        ) {
          out[sectionKey] = selectedDivision.id;
        }
      }

      return out;
    };

    if (!props.allDivisionRead && props.selectedDivisionIHV3) {
      const selectionMap = collectDivisionSelections(
        props.chartInfo,
        props.selectedDivisionIHV3
      );

      setSelectedDivision(selectionMap);
      console.log("selectionMap:", selectionMap);
    }
  }, [props.selectedDivisionIHV3, props.allDivisionRead, props.chartInfo])

  return (
  <>
    <div style={props.mobile ? { width: "100vw" } : {display: "grid", gridTemplateColumns: "15% 85%", width: "100vw"}}>
      {/* Left Pane - Selector */}
      {!props.mobile &&
      <Selector
        chartInfo={props.chartInfo}
        selectedDatasetId={props.datasetId}
        onSelectDataset={(datasetId: string) => {
          props.setState({ datasetId: datasetId });
        }}
      />}

      {/* Right panel - ChartPreviewContent */}
      <ChartPreviewContent
        datasetId={props.datasetId}
        selectedTab={props.selectedTab}
        showChart={props.showChart}
        chartInfo={props.chartInfo}
        mobile={props.mobile}
        useCloud={props.useCloud}
        urlPrefix={props.urlPrefix}
        toDownloadUrl={props.toDownloadUrl}
        setState={props.setState}
        onEvent={props.onEvent}
        Admin={props.Admin}
        width={props.width}
        height={props.height}
        filename={props.filename}
        agg={props.agg}
        filter={props.filter}
        colorValues={props.colorValues}
        loggedin={props.loggedin}
        dimList={props.dimList}
        duckLoaded={props.duckLoaded}
        socketMessage={props.socketMessage}
        clearSocketMessage={props.clearSocketMessage}
        allDivisionRead={props.allDivisionRead}
        selectedDivision={selectedDivision}
        setSelectedDivision={setSelectedDivision}
      />
    </div>
  </>
  )
}
